import { Component } from '@angular/core';

/**
 * The Confirm Component
 *
 * This component is the wrapper for confirm message
 */
@Component({
  selector: 'td-wb-confirm',
  templateUrl: 'confirm.component.html',
  styleUrls: ['confirm.component.scss']
})
export class ConfirmComponent {
}
